import styled from 'styled-components';

const ListTitle = styled.h2`
    margin: 20px 0 0 0;
    color:#4A5568;
    font-weight:600;    
`

export default ListTitle;
